import React from 'react'
import { dispatch } from '@rematch/core';
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import { Button, Modal, Card, Icon, Loader, TextArea, Message } from 'semantic-ui-react'
import TextEditor from '../../../../common/TextEditor';
import ImageResizer from '../../../../drive/ImageResizer/ImageResizer';
import setColor from '../../../../common/SetColor';
import defaultLogo from '../../../../../images/logo/logo-128.png';
import { toastr } from "react-redux-toastr";
import { versionNameValidation } from '../../../../common/RegexValidation';

const jiraSchema = [{
    "key": 1,
    "label": "url",
    "type": "String",
    "component": "text"
},
{
    "key": 2,
    "label": "email",
    "type": "String",
    "component": "text"
},
{
    "key": 3,
    "label": "password",
    "type": "String",
    "component": "text"
}]
// const salseForceSchema = [{
//     "key": 1,
//     "label": "Email",
//     "type": "String",
//     "component": "text"
// }, {
//     "key": 2,
//     "label": "Password",
//     "type": "String",
//     "component": "text"
// }]
// let options = [{
//     key: "Jira",
//     text: "Jira",
//     value: jiraSchema
// }, {
//     key: "SalseForce",
//     text: "SalseForce",
//     value: salseForceSchema
// }]


class AddNewIntegration extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            label: null,
            description: null,
            version: null,
            updatedImage: defaultLogo,
            loader: false,
            formcyButtonDisabled: false,
            checkDuplicatePluginName:false,
            // metaData: JSON.stringify(props.selectedIntegration.formBuilder, null, 2)
        }
        this.onSubmitNewIntegration = this.onSubmitNewIntegration.bind(this)
    }

    componentWillReceiveProps(newProps) {
        if (this.props.selectedIntegration !== newProps.selectedIntegration) {
            if (newProps.selectedIntegration) {
                this.setState({
                    updatedImage: newProps.selectedIntegration.image,
                    label: newProps.selectedIntegration.label,
                    description: newProps.selectedIntegration.description,
                    version: newProps.selectedIntegration.version,
                    formBuilder: JSON.stringify(newProps.selectedIntegration.formBuilder)
                    // formBuilder: newProps.selectedIntegration.formBuilder
                })
            } else {
                this.setState({
                    updatedImage: defaultLogo,
                    label: null,
                    description: null,
                    version: null,
                    formBuilder: null
                })
            }
        }
    }

    handleClose = () => {
        dispatch.platform.setIntegrationModal(false)
        dispatch.platform.setIntegrationModalType("")
        this.props.setSelectedIntegration(null);
        this.setState({ label: undefined, description: undefined, version: undefined, image: undefined, formBuilder: undefined, updatedImage: defaultLogo,checkDuplicatePluginName:false });
    }

    async onSubmitNewIntegration(formData) {
        if (this.props.integrationModalType === "edit") {
            let payload = {
                id: this.props.selectedIntegration._id,
                label: this.state.label,
                description: this.state.description,
                version: this.state.version,
                image: this.state.updatedImage,
                formBuilder: JSON.parse(this.state.formBuilder)
            }
            await dispatch.integrations.editIntegrations(payload)

            toastr.success("Integration", "Integration edited successfully.");

            dispatch.platform.setIntegrationModal(false);
            this.setState({ label: undefined, description: undefined, version: undefined, image: undefined,formBuilder: undefined });
            // editIntegrations

        } else if (this.props.integrationModalType === "add") {
            let payload = {
                id: (this.state.label).toLowerCase(),
                label: this.state.label,
                description: this.state.description,
                version: this.state.version,
                image: this.state.updatedImage,
                formBuilder: JSON.parse(this.state.formBuilder)
            }
            await dispatch.integrations.createIntegration(payload)

            toastr.success("Integration", "Integration added successfully.");

            dispatch.platform.setIntegrationModal(false);
            this.setState({ label: undefined, description: undefined, version: undefined, image: undefined,formBuilder: undefined });
        }
        // return false;



    }

    openImageModal = (open) => {
        this.setState({ open: open })
    }

    cloudinaryImage = (imageData) => {
        this.setState({ loader: true })
        if (imageData && imageData.data) {
            this.setState({ updatedImage: imageData.data.secure_url, loader: false })
        }
    }

    updateText = (data, name) => {
        if (name === "Plugin Name") {
            if(this.props.integrationsList && this.props.integrationsList.data && this.props.integrationsList.data.length>0 ){
                for (var i = 0; i < this.props.integrationsList.data.length; i++){
                    if(this.props.integrationsList.data[i].label.toLowerCase() === data.toLowerCase()){
                        this.setState({checkDuplicatePluginName:true})
                        this.buttonDisabled("e", false);
                        break;
                    }else{
                        this.setState({checkDuplicatePluginName:false})
                        this.buttonDisabled("e", true)
                    }
                }
            }
            this.setState({ label: data })
        }
        if (name === "Description") {
            this.setState({ description: data })
        }
        if (name === "Version") {
            let regex = /^\d+(\.\d+)*$/;
            let result = data.match(regex);
            this.setState({ version: data })
        }
    }
    updateSchema = (e, data) => {
        this.setState({ formBuilder: data.value, parse: true })
    }

    buttonDisabled = (e, set) => {
        this.setState({ formcyButtonDisabled: set });
    }

    handleIntegrationSchema = (e, data) => {
        this.setState({
            formBuilder: data.value
        })
    }
    IsValidJSONString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <Modal
                open={this.props.newIntegrationOpen}
                onClose={this.handleClose}
                size='tiny'
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Modal.Header>
                    {/* Add Integration */}
                    {this.props.integrationModalType === "add" ? "Add Integration" : this.props.integrationModalType === "edit" ? "Edit Integrations" : null}
                </Modal.Header>

                <Modal.Content className="pad_20" scrolling>
                    <Card className="userProfilePic" style={{ margin: "10px auto" }}>
                        <Card.Content >
                            <div >
                                {this.state.loader ? <Loader active /> : null}
                                {this.state.updatedImage ?
                                    <img src={this.state.updatedImage} className="fitImage" alt="User Profile Pic" /> :
                                    null
                                }
                                <Button className="circular_24_icon circle-image" icon='pencil' type="file" onClick={() => this.openImageModal(true)} />
                            </div >
                        </Card.Content>
                    </Card>

                    <ImageResizer
                        image={this.state.updatedImage}
                        openImageModal={this.openImageModal}
                        cloudinaryImage={this.cloudinaryImage}
                        open={this.state.open}
                        envData={this.props.envData}
                        width={120}
                        height={120}
                        borderRadius={500}
                    />

                    <Form noValidate
                        ref={ref => this.form = ref}
                        className="formcyForm"
                        name="issue"
                        id="issueid"
                        onValidSubmit={this.onSubmitNewIntegration}
                        onValid={(e) => this.buttonDisabled(e, true)}
                        onInvalid={(e) => this.buttonDisabled(e, false)}
                    >

                        <TextEditor
                            name="Plugin Name"
                            text={this.state.label}
                            type="text"
                            onChangeText={this.updateText}
                            autoFocus={true}
                        />
                        <Form.Input
                            required
                            name="Version"
                            label="Version"
                            value={this.state.version}
                            type="text"
                            onChange={e=>{this.updateText(e.target.value, "Version")}}
                            autoFocus={false}
                            errorLabel={errorLabel}
                            versionValidation={true}
                            instantValidation
                            validations={{ matchRegexp: versionNameValidation }}
                            validationErrors={{
                                matchRegexp: 'Version is not correct.',
                                isDefaultRequiredValue: "Version is required",
                            }}
                        />
                        <label>Schema</label>
                        <TextArea
                            name="Metadata"    
                            value={this.state.formBuilder}
                            fluid
                            placeholder='Add valid json schema'
                            style={{ minHeight: "120px" }}
                            className="w_100"
                            onChange={(e, data) => this.updateSchema(e, data)}
                        />

                        {this.state.formBuilder && this.state.formBuilder.length !== 0 && !this.IsValidJSONString(this.state.formBuilder) ?
                            <Message className="bg-warning"
                                style={{
                                    float: "left",
                                    padding: "8px",
                                    width: "calc(100% - 200px)",
                                    textAlign: "left"
                                }}
                                content='Please validate Json to enable button'
                            /> : null}

                        {this.state.checkDuplicatePluginName ?
                            <Message className="bg-warning"
                                style={{
                                    float: "left",
                                    padding: "8px",
                                    width: "calc(100% - 200px)",
                                    textAlign: "left"
                                }}
                                content='Plugin name already exists'
                            /> : null}

                    </Form>
                    {/* <div style={{ margin: "5px 0" }}>Select Plugin</div>
                        <Dropdown
                            style={{ margin: "0 0 15px " }}
                            label="Select Plugin"
                            className="noPointing"
                            name="Category"
                            pointing={this.props.dropdownPointing ? this.props.dropdownPointing : "top"}
                            value={this.state.metaData}
                            //disabled={!this.state.kb || this.state.allCat && this.state.allCat.length === 0}
                            placeholder="Select"
                            fluid
                            selection
                            required
                            validationErrors={{
                                isDefaultRequiredValue: 'You need to select a Category',
                            }}
                            errorLabel={errorLabel}
                            options={options}
                            onChange={(e, value) => { this.handleIntegrationSchema(e, value) }}
                        /> */}

                    {/* <TextEditor
                            name="Description"
                            text={this.state.description}
                            type="textarea"
                            onChangeText={this.updateText}
                            autoFocus={false}
                        /> */}
                </Modal.Content>
                <Modal.Actions className="actionInFormcy">
                    <Button
                        disabled={this.state.loader || this.state.checkDuplicatePluginName || !this.state.formcyButtonDisabled || !this.IsValidJSONString(this.state.formBuilder )}
                        type="submit"
                        onClick={this.onSubmitNewIntegration}
                        content={this.props.integrationModalType === "add" ? "Create" : this.props.integrationModalType === "edit" ? "Update" : null}
                        // content='Create'
                        className="button-submit float-right" />
                    <Button
                        content='Cancel'
                        className="button-cancel"
                        onClick={this.handleClose}
                    />
                </Modal.Actions>

            </Modal >
        )
    }
}


export default AddNewIntegration